import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2031e7fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator" }, null, -1 /* HOISTED */))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.swipedUp && !$setup.isShowingKeyboard)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "expandable-modal-wrapper",
          onClick: $setup.handleBackdropClick
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      ref: "containerRef",
      class: "expandable-modal",
      style: _normalizeStyle($setup.containerStyle)
    }, [
      _createElementVNode("div", {
        class: "expandable-modal__header",
        onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onTouchStart && $setup.onTouchStart(...args))),
        onTouchmove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onTouchMove && $setup.onTouchMove(...args))),
        onTouchend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onTouchEnd && $setup.onTouchEnd(...args)))
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "expandable-modal__header-button",
          "aria-label": "노선 목록 보기",
          onClick: $setup.handleClickIndicator
        }, [..._hoisted_2])
      ], 32 /* NEED_HYDRATION */),
      _createElementVNode("div", {
        class: "expandable-modal__content",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _renderSlot(_ctx.$slots, "content", { onOnContentHeightChange: $setup.handleContentHeightChange }, undefined, true)
      ])
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}